import React, { useState } from 'react';

function ToggleButton({state, onClick = () => {}}) {


  return (
    <img
      className='is_on cursor-point ml-20'
      src={state ? '/assets/image/is_on.png' : '/assets/image/is_off.png'}
      alt=''
      onClick={() => onClick(prev => !prev)}
    />
  );
}

export default ToggleButton;
